import { Image, Link } from "@/components/Elements";
import { NotificationCategory } from "@/features/misc/types/notification";
import usePermission from "@/hooks/usePermission";
import { RouteConstant } from "@/routes/routeConstant";
import { useGetNotificationCountMutation } from "@/services/modules/chat";
import { useEffect } from "react";

export const Header = () => {
  const [getNotificationCount, data] = useGetNotificationCountMutation();
  const notificationCount = data.data;
  const { showPost, showArticle, showEvent, showFriend } = usePermission();

  useEffect(() => {
    getNotificationCount(NotificationCategory.Post);
  }, []);

  return (
    <div className="flex justify-between items-center p-[10px] pb-0 bg-[#ffffff] min-w-[250px]">
      {showPost && (
        <Link
          className="w-[22px] h-[22px]"
          to={RouteConstant.AddPost}
          title="Add Post"
        >
          <Image src="plus.png" className="w-full h-full" />
        </Link>
      )}
      <Link
        className="w-[22px] h-[22px]"
        to={RouteConstant.Profile}
        title="View Profile"
      >
        <Image src="user1.png" className="w-full h-full" />
      </Link>
      {showFriend && (
        <Link
          className="w-[22px] h-[22px]"
          to={RouteConstant.Friends}
          title="Friends"
        >
          <Image src="chat2.png" className="w-full h-full" />
        </Link>
      )}
      {showArticle && (
        <>
          <Link
            className="w-[22px] h-[22px]"
            to={RouteConstant.AddArticle}
            title="Add Article"
          >
            <Image src="add-article.png" className="w-full h-full" />
          </Link>
          <Link
            className="w-[22px] h-[22px]"
            to={RouteConstant.Articles}
            title="Articles"
          >
            <Image src="article.png" className="w-full h-full" />
          </Link>
        </>
      )}
      {showEvent && (
        <>
          <Link
            className="w-[22px] h-[22px]"
            to={RouteConstant.AddEvent}
            title="Add Event"
          >
            <Image src="add-event.png" className="w-full h-full" />
          </Link>
          <Link
            className="w-[22px] h-[22px]"
            to={RouteConstant.Events}
            title="Events"
          >
            <Image src="event.png" className="w-full h-full" />
          </Link>
        </>
      )}
      <Link
        className="w-[22px] h-[22px]"
        to={`${RouteConstant.Notification}/${NotificationCategory.Post}`}
        title="Notifications"
      >
        <Image src="bell.png" className="w-full h-full" />
        {notificationCount != undefined && notificationCount > 0 && (
          <div className="w-[18px] h-[18px] bg-[#e8434d] rounded-[7px] items-center justify-center absolute top-[-10px] right-[-10px]">
            <div className="text-[11px] text-[#fff]">{notificationCount}</div>
          </div>
        )}
      </Link>
    </div>
  );
};
